export function guidesValidate(guides){
    var result = true;

    result = validateValues(guides.data);
    result = validateMeta(guides.meta);

    return result;
}

function validateValues(guides) {
    return Array.isArray(guides) &&
        guides.every(item =>
        typeof item.attributes === 'object' &&
        item.attributes !== null &&
        typeof item.id === 'number' &&
        !isNaN(item.id) &&
        typeof item.attributes.client_reference_id === 'string' &&
        item.attributes.client_reference_id.trim() !== ''&&

        typeof item.attributes.client === 'string' &&
        item.attributes.client.trim() !== ''&&
        
        typeof item.attributes.date === 'string' &&
        item.attributes.date.trim() !== ''&&

        typeof item.attributes.master_tracking_number === 'string' &&
        item.attributes.master_tracking_number.trim() !== ''&&

        typeof item.attributes.status === 'string' &&
        item.attributes.status.trim() !== ''&&

        typeof item.attributes.payment_status === 'string' &&
        item.attributes.payment_status.trim() !== ''&&

        typeof item.attributes.total_weight === 'number' &&
        !isNaN(item.attributes.total_weight) &&

        typeof item.attributes.destination === 'string' &&
        item.attributes.destination.trim() !== ''&&

        typeof item.attributes.origin === 'string' &&
        item.attributes.origin.trim() !== ''&&
        
        typeof item.attributes.zone === 'number' &&
        !isNaN(item.attributes.zone) &&

        typeof item.attributes.tracking_number === 'string' &&
        item.attributes.tracking_number.trim() !== '')
}

function validateMeta(meta) {
    return (typeof meta === 'object' &&
        meta !== null &&
        typeof meta.total === 'number' &&
        !isNaN(meta.total) && 

        typeof meta.total_pages === 'number' &&
        !isNaN(meta.total_pages) && 
        
        typeof meta.per_page === 'number' &&
        !isNaN(meta.per_page) && 
        
        typeof meta.page === 'number' &&
        !isNaN(meta.page))
}